import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import * as UsersSelectors from 'Shared/selectors/Users.selectors';

// Helpers
import WorkspaceRecentUpdatesHelper from 'Shared/model_helpers/WorkspaceRecentUpdates.helper';

// Utils
import { timestampToDate, getTimeAgoLabel } from 'Shared/utils/DateTime.utils';

// Components
import WpAvatar from 'Wpds/components/avatar/WpAvatar';

// Hooks
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

// Styles
import './NotificationHeader.scss';

type Props = {
  notification;
  label: string | React.ReactNode;
};

const NotificationHeader = ({ notification, label }: Props) => {
  const userId = WorkspaceRecentUpdatesHelper.getUserId(notification);
  const meetingItemUuid = WorkspaceRecentUpdatesHelper.getMeetingItemUuid(notification);
  const commentItemUuid = WorkspaceRecentUpdatesHelper.getWorkspaceCommentUuid(notification);
  const time = WorkspaceRecentUpdatesHelper.getTime(notification);

  const { workspace } = useWorkspace();
  const user = useSelector(state => UsersSelectors.getUserByUserId(state, { userId })).toJS();
  const userNameOrEmail = user.fullName || user.email;
  const timeAgoLabel = getTimeAgoLabel(timestampToDate(time));

  const workspaceLastViewed = workspace.workspaceNotifications.viewedWorkspaceTime;
  const modifiedItemsUuids = workspace.workspaceNotifications.modifiedItemsUuids || [];
  const modifiedCommentsUuids = workspace.workspaceNotifications.modifiedCommentsUuids || [];

  const showNewBadge =
    time > workspaceLastViewed &&
    (modifiedItemsUuids.findIndex(uuid => uuid === meetingItemUuid) > -1 ||
      modifiedCommentsUuids.findIndex(uuid => uuid === commentItemUuid) > -1);

  const baseClassName = 'NotificationHeader';

  return (
    <div className={baseClassName}>
      {showNewBadge && <div className={`${baseClassName}__new-indicator`} />}
      <WpAvatar avatar={user.avatar} />
      <div className={`${baseClassName}__details`}>
        <div className={`${baseClassName}__details__name-time`}>
          <div className={`${baseClassName}__details__name-time__name`}>{userNameOrEmail}</div>
          <div className={`${baseClassName}__details__name-time__time`}>{timeAgoLabel}</div>
        </div>
        <div className={`${baseClassName}__details__label`}>{label}</div>
      </div>
    </div>
  );
};

export default NotificationHeader;
